export default "__VITE_ASSET__BJ7ArbLZ__"